// Split on an unescaped single-character delimiter. A backslash before the
// delimiter keeps it inside the value ("a\,b" -> one value "a,b"). Used by
// the widgets whose list props are comma/semicolon-delimited strings.
export function splitEscaped(input: string, delim: string): string[] {
  const out: string[] = [];
  let cur = "";
  for (let i = 0; i < input.length; i++) {
    const ch = input[i]!;
    if (ch === "\\" && input[i + 1] === delim) {
      cur += delim;
      i++;
    } else if (ch === delim) {
      out.push(cur);
      cur = "";
    } else {
      cur += ch;
    }
  }
  out.push(cur);
  return out;
}
